var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"menu_principal"},[_vm._l((_vm.items),function(item,idx){return _c('router-link',{key:_vm.items[idx],class:{'red-active-link': _vm.isSubsActive(item)},attrs:{"to":_vm.itemRoute(idx)}},[_c('MenuButton',{attrs:{"texto":_vm.buttonText[idx],"offset":_vm.calcOffset(idx)}})],1)}),_c('MenuContacto')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }